import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import axiosInstance from "../../api/axiosInstance";
import { getUserId } from "../../utils/basicPlanAccess";

export const useYears = () => {
  const { token, user } = useSelector((state) => state.user);
  const userId = getUserId(user) || "anonymous";

  return useQuery({
    queryKey: ["years", userId, token ? "authenticated" : "guest"],
    queryFn: async () => {
      const response = await axiosInstance.get("api/allyears");
      return response.data;
    },
    enabled: Boolean(token),
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
};
